var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import produce from 'immer';
import { REFRESH_PATCHWORK_REQUEST, LOAD_PATCHWORK_REQUEST, LOAD_PATCHWORK_SUCCESS, LOAD_PATCHWORK_FAILURE, UPDATE_PATCHWORK_REQUEST, UPDATE_PATCHWORK_SUCCESS, UPDATE_PATCHWORK_FAILURE, CREATE_PATCH_REQUEST, CREATE_PATCH_SUCCESS, CREATE_PATCH_FAILURE, UPDATE_PATCH_REQUEST, UPDATE_PATCH_SUCCESS, UPDATE_PATCH_FAILURE, CREATE_EDGE_REQUEST, CREATE_EDGE_SUCCESS, CREATE_EDGE_FAILURE, UPDATE_EDGE_SUCCESS, LOAD_VIEW_REQUEST, LOAD_VIEW_SUCCESS, LOAD_VIEW_FAILURE, LOAD_DATASET_REQUEST, LOAD_DATASET_SUCCESS, LOAD_DATASET_FAILURE, DELETE_PATCH_REQUEST, DELETE_PATCH_SUCCESS, DELETE_PATCH_FAILURE, DELETE_EDGE_REQUEST, DELETE_EDGE_SUCCESS, DELETE_EDGE_FAILURE, LOAD_GROUPS_REQUEST, LOAD_GROUPS_SUCCESS, LOAD_GROUPS_FAILURE, viewStates, LOAD_ICONS_REQUEST, LOAD_ICONS_SUCCESS, LOAD_ICONS_FAILURE, LOAD_DATASET_ROWS_REQUEST, LOAD_DATASET_ROWS_SUCCESS, LOAD_DATASET_ROWS_FAILURE, SET_LOADING_STATE, UPDATE_CANVAS_OFFSET, UPDATE_PATCHWORK_ENTRYPOINT, UPDATE_PATCHWORK_ENTRYPOINT_SUCCESS, UPDATE_PATCHWORK_ENTRYPOINT_FAIL, LOAD_INTEGRATION_REQUEST, LOAD_INTEGRATION_SUCCESS, LOAD_INTEGRATION_FAILURE, SELECT_GROUP, SELECT_GROUP_CHANGING, UPDATE_EDGE_REQUEST, UPDATE_EDGE_FAILURE, COPY_LOGIC_REQUEST, COPY_LOGIC_SUCCESS, COPY_LOGIC_FAILURE, COPY_LOGIC_GROUP_REQUEST, COPY_LOGIC_GROUP_SUCCESS, COPY_LOGIC_GROUP_FOCAL_PATCH, COPY_LOGIC_GROUP_FAILURE, CREATE_VIEW_EVENT_REQUEST, CREATE_VIEW_EVENT_SUCCESS, CREATE_VIEW_EVENT_FAILURE, CREATE_VIEW_REQUEST, CREATE_VIEW_SUCCESS, CREATE_VIEW_FAILURE, CHANGE_VIEW_NAME_REQUEST, CHANGE_VIEW_NAME_SUCCESS, CHANGE_VIEW_NAME_FAILURE, UPDATE_PATCH_COORDS_REQUEST, UPDATE_PATCH_COORDS_SUCCESS, UPDATE_PATCH_COORDS_FAILURE, SET_GLOBAL_STYLES_REQUEST, SET_GLOBAL_STYLES_SUCCESS, SET_GLOBAL_STYLES_FAILURE, BULK_DELETE_PATCHES_REQUEST, BULK_DELETE_PATCHES_SUCCESS, BULK_DELETE_PATCHES_FAILURE, } from './constants';
import { findPatchIndex } from './utils';
import { LOAD_FILES_FAILURE, LOAD_FILES_REQUEST, LOAD_FILES_SUCCESS, } from '../ViewBuilder/constants';
import { faBars } from '@fortawesome/pro-regular-svg-icons/faBars';
import { faAngleLeft } from '@fortawesome/pro-regular-svg-icons/faAngleLeft';
import { faAngleRight } from '@fortawesome/pro-regular-svg-icons/faAngleRight';
import { faSortAmountDown } from '@fortawesome/pro-regular-svg-icons/faSortAmountDown';
import { faEllipsisV } from '@fortawesome/pro-regular-svg-icons/faEllipsisV';
import { faPlus } from '@fortawesome/pro-regular-svg-icons/faPlus';
export var initialState = {
    viewState: viewStates.init,
    patchwork: {
        entrypoint: null,
        originalEntrypoint: null,
        patches: [],
        edges: [],
    },
    focalPatch: '',
    files: [],
    filesMeta: {},
    meta: {},
    views: [],
    views_loading: false,
    views_error: false,
    datasets: [],
    datasetRules: [],
    datasets_loading: false,
    datasets_error: false,
    datasetRows: {},
    dataset_rows_loading: false,
    dataset_rows_error: false,
    patch_deleting: false,
    patch_delete_error: false,
    edge_deleting: false,
    edge_delete_error: false,
    groups: [],
    groups_loading: false,
    groups_error: false,
    icons_error: false,
    icons_loading: false,
    icons: [],
    integrations: [],
    integrations_loading: false,
    integrations_error: false,
    created_view: false,
    temp_new_patch: null,
    canvasOffset: {
        x: 0,
        y: 0,
    },
    selectedGroup: null,
    selectGroupChanging: false,
    styles_data: {
        backgroundColor: '#ffffff',
        secondaryBackgroundColor: '#ffffff',
        primaryColor: '#36e0b7',
        secondaryColor: '#0e3951',
        topBarColor: '#ececec',
        topBarColor2: '',
        topBarGradient: false,
        topBarGradientCutoff: 1,
        topBarBackgroundImage: '',
        topBarBackgroundImageSize: '',
        topBarDrawerButtonIcon: faBars,
        topBarDrawerButtonColor: '#ffffff',
        topBarDrawerButtonBackgroundColor: '#36e0b7',
        topBarDrawerButtonBorderColor: '#ffffff',
        topBarDrawerButtonBorderWidth: 0,
        topBarDrawerButtonBorderRadius: 0,
        topBarDrawerButtonBorderLeftColor: '#ffffff',
        topBarDrawerButtonBorderLeftWidth: 0,
        topBarDrawerButtonBorderRightColor: '#ffffff',
        topBarDrawerButtonBorderRightWidth: 0,
        topBarDrawerButtonBorderTopColor: '#ffffff',
        topBarDrawerButtonBorderTopWidth: 0,
        topBarDrawerButtonBorderBottomColor: '#ffffff',
        topBarDrawerButtonBorderBottomWidth: 0,
        topBarDrawerButtonBorderStyle: 'solid',
        topBarDrawerButtonBorderTopLeftRadius: 0,
        topBarDrawerButtonBorderTopRightRadius: 0,
        topBarDrawerButtonBorderBottomLeftRadius: 0,
        topBarDrawerButtonBorderBottomRightRadius: 0,
        topBarBackButtonIcon: faAngleLeft,
        topBarBackButtonColor: '#ffffff',
        topBarBackButtonBackgroundColor: '#36e0b7',
        topBarBackButtonBorderLeftColor: '#ffffff',
        topBarBackButtonBorderLeftWidth: 0,
        topBarBackButtonBorderRightColor: '#ffffff',
        topBarBackButtonBorderRightWidth: 0,
        topBarBackButtonBorderTopColor: '#ffffff',
        topBarBackButtonBorderTopWidth: 0,
        topBarBackButtonBorderBottomColor: '#ffffff',
        topBarBackButtonBorderBottomWidth: 0,
        topBarBackButtonBorderStyle: 'solid',
        topBarBackButtonBorderTopLeftRadius: 0,
        topBarBackButtonBorderTopRightRadius: 0,
        topBarBackButtonBorderBottomLeftRadius: 0,
        topBarBackButtonBorderBottomRightRadius: 0,
        topBarPreviousButtonIcon: faAngleLeft,
        topBarPreviousButtonColor: '#ffffff',
        topBarPreviousButtonBackgroundColor: '#36e0b7',
        topBarPreviousButtonBorderLeftColor: '#ffffff',
        topBarPreviousButtonBorderLeftWidth: 0,
        topBarPreviousButtonBorderRightColor: '#ffffff',
        topBarPreviousButtonBorderRightWidth: 0,
        topBarPreviousButtonBorderTopColor: '#ffffff',
        topBarPreviousButtonBorderTopWidth: 0,
        topBarPreviousButtonBorderBottomColor: '#ffffff',
        topBarPreviousButtonBorderBottomWidth: 0,
        topBarPreviousButtonBorderStyle: 'solid',
        topBarPreviousButtonBorderTopLeftRadius: 0,
        topBarPreviousButtonBorderTopRightRadius: 0,
        topBarPreviousButtonBorderBottomLeftRadius: 0,
        topBarPreviousButtonBorderBottomRightRadius: 0,
        topBarNextButtonIcon: faAngleRight,
        topBarNextButtonColor: '#ffffff',
        topBarNextButtonBackgroundColor: '#36e0b7',
        topBarNextButtonBorderLeftColor: '#ffffff',
        topBarNextButtonBorderLeftWidth: 0,
        topBarNextButtonBorderRightColor: '#ffffff',
        topBarNextButtonBorderRightWidth: 0,
        topBarNextButtonBorderTopColor: '#ffffff',
        topBarNextButtonBorderTopWidth: 0,
        topBarNextButtonBorderBottomColor: '#ffffff',
        topBarNextButtonBorderBottomWidth: 0,
        topBarNextButtonBorderStyle: 'solid',
        topBarNextButtonBorderTopLeftRadius: 0,
        topBarNextButtonBorderTopRightRadius: 0,
        topBarNextButtonBorderBottomLeftRadius: 0,
        topBarNextButtonBorderBottomRightRadius: 0,
        topBarSortButtonIcon: faSortAmountDown,
        topBarSortButtonColor: '#ffffff',
        topBarSortButtonBackgroundColor: '#36E0B7',
        topBarSortButtonBorderLeftColor: '#ffffff',
        topBarSortButtonBorderLeftWidth: 0,
        topBarSortButtonBorderRightColor: '#ffffff',
        topBarSortButtonBorderRightWidth: 0,
        topBarSortButtonBorderTopColor: '#ffffff',
        topBarSortButtonBorderTopWidth: 0,
        topBarSortButtonBorderBottomColor: '#ffffff',
        topBarSortButtonBorderBottomWidth: 0,
        topBarSortButtonBorderStyle: 'solid',
        topBarSortButtonBorderTopLeftRadius: 0,
        topBarSortButtonBorderTopRightRadius: 0,
        topBarSortButtonBorderBottomLeftRadius: 0,
        topBarSortButtonBorderBottomRightRadius: 0,
        topBarContextButtonIcon: faEllipsisV,
        topBarContextButtonColor: '#ffffff',
        topBarContextButtonBackgroundColor: '#36E0B7',
        topBarContextButtonBorderLeftColor: '#ffffff',
        topBarContextButtonBorderLeftWidth: 0,
        topBarContextButtonBorderRightColor: '#ffffff',
        topBarContextButtonBorderRightWidth: 0,
        topBarContextButtonBorderTopColor: '#ffffff',
        topBarContextButtonBorderTopWidth: 0,
        topBarContextButtonBorderBottomColor: '#ffffff',
        topBarContextButtonBorderBottomWidth: 0,
        topBarContextButtonBorderStyle: 'solid',
        topBarContextButtonBorderTopLeftRadius: 0,
        topBarContextButtonBorderTopRightRadius: 0,
        topBarContextButtonBorderBottomLeftRadius: 0,
        topBarContextButtonBorderBottomRightRadius: 0,
        topBarAddButtonIcon: faPlus,
        topBarAddButtonColor: '#ffffff',
        topBarAddButtonBackgroundColor: '#36E0B7',
        topBarAddButtonBorderLeftColor: '#ffffff',
        topBarAddButtonBorderLeftWidth: 0,
        topBarAddButtonBorderRightColor: '#ffffff',
        topBarAddButtonBorderRightWidth: 0,
        topBarAddButtonBorderTopColor: '#ffffff',
        topBarAddButtonBorderTopWidth: 0,
        topBarAddButtonBorderBottomColor: '#ffffff',
        topBarAddButtonBorderBottomWidth: 0,
        topBarAddButtonBorderStyle: 'solid',
        topBarAddButtonBorderTopLeftRadius: 0,
        topBarAddButtonBorderTopRightRadius: 0,
        topBarAddButtonBorderBottomLeftRadius: 0,
        topBarAddButtonBorderBottomRightRadius: 0,
        topBarCarouselIndicatorBorderWidth: 0,
        topBarCarouselIndicatorBorderStyle: 'solid',
        topBarCarouselIndicatorBorderColor: '#ffffff',
        topBarCarouselIndicatorBackgroundColor: '#cccccc',
        topBarCarouselIndicatorBackgroundOpacity: 100,
        topBarCarouselIndicatorSelectedBorderWidth: 0,
        topBarCarouselIndicatorSelectedBorderStyle: 'solid',
        topBarCarouselIndicatorSelectedBorderColor: '#ffffff',
        topBarCarouselIndicatorSelectedBackgroundColor: '#cccccc',
        topBarCarouselIndicatorSelectedBackgroundOpacity: 100,
        menuBackgroundColor: '#ffffff',
        menuBackgroundColor2: '',
        menuBackgroundGradient: false,
        menuSelectedItemColor: 'transparent',
        menuBackgroundGradientCutoff: 1,
        menuBackgroundImage: '',
        menuBackgroundImageSize: '',
        subMenuBarBackgroundColor: '#ececec',
        subMenuBarBackgroundColor2: '',
        subMenuBarBackgroundGradient: false,
        subMenuBarBackgroundGradientCutoff: 1,
        subMenuBarBackgroundImage: '',
        subMenuBarBackgroundImageSize: 'cover',
        subMenuBarBackgroundPaddings: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingRight: 0,
            paddingBottom: 0,
        },
        subMenuBarBackgroundBorderLeftColor: '#ffffff',
        subMenuBarBackgroundBorderLeftWidth: 0,
        subMenuBarBackgroundBorderRightColor: '#ffffff',
        subMenuBarBackgroundBorderRightWidth: 0,
        subMenuBarBackgroundBorderTopColor: '#ffffff',
        subMenuBarBackgroundBorderTopWidth: 0,
        subMenuBarBackgroundBorderBottomColor: '#ffffff',
        subMenuBarBackgroundBorderBottomWidth: 0,
        subMenuBarBackgroundBorderStyle: 'solid',
        subMenuBarBackgroundBorderTopLeftRadius: 0,
        subMenuBarBackgroundBorderTopRightRadius: 0,
        subMenuBarBackgroundBorderBottomLeftRadius: 0,
        subMenuBarBackgroundBorderBottomRightRadius: 0,
        subMenuButtonBackgroundColor: '#ececec',
        subMenuButtonFlexDirection: 'row',
        subMenuButtonJustifyContent: 'center',
        subMenuButtonAlignItems: 'center',
        subMenuButtonPaddings: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingRight: 0,
            paddingBottom: 0,
        },
        subMenuButtonBorderLeftColor: '#ffffff',
        subMenuButtonBorderLeftWidth: 0,
        subMenuButtonBorderRightColor: '#ffffff',
        subMenuButtonBorderRightWidth: 0,
        subMenuButtonBorderTopColor: '#ffffff',
        subMenuButtonBorderTopWidth: 0,
        subMenuButtonBorderBottomColor: '#ffffff',
        subMenuButtonBorderBottomWidth: 0,
        subMenuButtonBorderStyle: 'solid',
        subMenuButtonBorderTopLeftRadius: 0,
        subMenuButtonBorderTopRightRadius: 0,
        subMenuButtonBorderBottomLeftRadius: 0,
        subMenuButtonBorderBottomRightRadius: 0,
        subMenuButtonSelectedBackgroundColor: '#ececec',
        subMenuButtonSelectedFlexDirection: 'row',
        subMenuButtonSelectedJustifyContent: 'center',
        subMenuButtonSelectedAlignItems: 'center',
        subMenuButtonSelectedPaddings: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingRight: 0,
            paddingBottom: 0,
        },
        subMenuButtonSelectedBorderLeftColor: '#ffffff',
        subMenuButtonSelectedBorderLeftWidth: 0,
        subMenuButtonSelectedBorderRightColor: '#ffffff',
        subMenuButtonSelectedBorderRightWidth: 0,
        subMenuButtonSelectedBorderTopColor: '#ffffff',
        subMenuButtonSelectedBorderTopWidth: 0,
        subMenuButtonSelectedBorderBottomColor: '#ffffff',
        subMenuButtonSelectedBorderBottomWidth: 0,
        subMenuButtonSelectedBorderStyle: 'solid',
        subMenuButtonSelectedBorderTopLeftRadius: 0,
        subMenuButtonSelectedBorderTopRightRadius: 0,
        subMenuButtonSelectedBorderBottomLeftRadius: 0,
        subMenuButtonSelectedBorderBottomRightRadius: 0,
        subMenuButtonTextFontFamily: 'System',
        subMenuButtonTextFontWeight: 'normal',
        subMenuButtonTextFontColor: '#000000',
        subMenuButtonTextFontSize: 18,
        subMenuButtonTextFontStyle: 'normal',
        subMenuButtonTextTextDecoration: 'none',
        subMenuButtonTextTextTransform: 'none',
        subMenuButtonTextTextShadowColor: '#ffffff',
        subMenuButtonTextTextShadowRadius: 0,
        subMenuButtonTextLetterSpacing: 0,
        subMenuButtonTextNumberOfLines: 1,
        subMenuButtonTextEllipsizeMode: 'tail',
        subMenuButtonTextFlexDirection: 'row',
        subMenuButtonTextJustifyContent: 'center',
        subMenuButtonTextAlignItems: 'center',
        subMenuButtonTextPaddings: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingRight: 0,
            paddingBottom: 0,
        },
        subMenuButtonTextBorderLeftColor: '#ffffff',
        subMenuButtonTextBorderLeftWidth: 0,
        subMenuButtonTextBorderRightColor: '#ffffff',
        subMenuButtonTextBorderRightWidth: 0,
        subMenuButtonTextBorderTopColor: '#ffffff',
        subMenuButtonTextBorderTopWidth: 0,
        subMenuButtonTextBorderBottomColor: '#ffffff',
        subMenuButtonTextBorderBottomWidth: 0,
        subMenuButtonTextBorderStyle: 'solid',
        subMenuButtonTextBorderTopLeftRadius: 0,
        subMenuButtonTextBorderTopRightRadius: 0,
        subMenuButtonTextBorderBottomLeftRadius: 0,
        subMenuButtonTextBorderBottomRightRadius: 0,
        subMenuButtonTextSelectedFontFamily: 'System',
        subMenuButtonTextSelectedFontWeight: 'normal',
        subMenuButtonTextSelectedFontColor: '#000000',
        subMenuButtonTextSelectedFontSize: 18,
        subMenuButtonTextSelectedFontStyle: 'normal',
        subMenuButtonTextSelectedTextDecoration: 'none',
        subMenuButtonTextSelectedTextTransform: 'none',
        subMenuButtonTextSelectedTextShadowColor: '#ffffff',
        subMenuButtonTextSelectedTextShadowRadius: 0,
        subMenuButtonTextSelectedLetterSpacing: 0,
        subMenuButtonTextSelectedNumberOfLines: 1,
        subMenuButtonTextSelectedEllipsizeMode: 'tail',
        subMenuButtonTextSelectedFlexDirection: 'row',
        subMenuButtonTextSelectedJustifyContent: 'center',
        subMenuButtonTextSelectedAlignItems: 'center',
        subMenuButtonTextSelectedPaddings: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingRight: 0,
            paddingBottom: 0,
        },
        subMenuButtonTextSelectedBorderLeftColor: '#ffffff',
        subMenuButtonTextSelectedBorderLeftWidth: 0,
        subMenuButtonTextSelectedBorderRightColor: '#ffffff',
        subMenuButtonTextSelectedBorderRightWidth: 0,
        subMenuButtonTextSelectedBorderTopColor: '#ffffff',
        subMenuButtonTextSelectedBorderTopWidth: 0,
        subMenuButtonTextSelectedBorderBottomColor: '#ffffff',
        subMenuButtonTextSelectedBorderBottomWidth: 0,
        subMenuButtonTextSelectedBorderStyle: 'solid',
        subMenuButtonTextSelectedBorderTopLeftRadius: 0,
        subMenuButtonTextSelectedBorderTopRightRadius: 0,
        subMenuButtonTextSelectedBorderBottomLeftRadius: 0,
        subMenuButtonTextSelectedBorderBottomRightRadius: 0,
        tabBarBackgroundColor: '#ececec',
        tabBarBackgroundColor2: '',
        tabBarBackgroundGradient: false,
        tabBarBackgroundGradientCutoff: 1,
        tabBarBackgroundImage: '',
        tabBarBackgroundImageSize: 'cover',
        tabBarBackgroundPaddings: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingRight: 0,
            paddingBottom: 0,
        },
        tabBarBackgroundBorderLeftColor: '#ffffff',
        tabBarBackgroundBorderLeftWidth: 0,
        tabBarBackgroundBorderRightColor: '#ffffff',
        tabBarBackgroundBorderRightWidth: 0,
        tabBarBackgroundBorderTopColor: '#ffffff',
        tabBarBackgroundBorderTopWidth: 0,
        tabBarBackgroundBorderBottomColor: '#ffffff',
        tabBarBackgroundBorderBottomWidth: 0,
        tabBarBackgroundBorderStyle: 'solid',
        tabBarBackgroundBorderTopLeftRadius: 0,
        tabBarBackgroundBorderTopRightRadius: 0,
        tabBarBackgroundBorderBottomLeftRadius: 0,
        tabBarBackgroundBorderBottomRightRadius: 0,
        tabButtonBackgroundColor: '#ececec',
        tabButtonFlexDirection: 'row',
        tabButtonJustifyContent: 'center',
        tabButtonAlignItems: 'center',
        tabButtonPaddings: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingRight: 0,
            paddingBottom: 0,
        },
        tabButtonBorderLeftColor: '#ffffff',
        tabButtonBorderLeftWidth: 0,
        tabButtonBorderRightColor: '#ffffff',
        tabButtonBorderRightWidth: 0,
        tabButtonBorderTopColor: '#ffffff',
        tabButtonBorderTopWidth: 0,
        tabButtonBorderBottomColor: '#ffffff',
        tabButtonBorderBottomWidth: 0,
        tabButtonBorderStyle: 'solid',
        tabButtonBorderTopLeftRadius: 0,
        tabButtonBorderTopRightRadius: 0,
        tabButtonBorderBottomLeftRadius: 0,
        tabButtonBorderBottomRightRadius: 0,
        tabButtonSelectedBackgroundColor: '#ececec',
        tabButtonSelectedFlexDirection: 'row',
        tabButtonSelectedJustifyContent: 'center',
        tabButtonSelectedAlignItems: 'center',
        tabButtonSelectedPaddings: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingRight: 0,
            paddingBottom: 0,
        },
        tabButtonSelectedBorderLeftColor: '#ffffff',
        tabButtonSelectedBorderLeftWidth: 0,
        tabButtonSelectedBorderRightColor: '#ffffff',
        tabButtonSelectedBorderRightWidth: 0,
        tabButtonSelectedBorderTopColor: '#ffffff',
        tabButtonSelectedBorderTopWidth: 0,
        tabButtonSelectedBorderBottomColor: '#ffffff',
        tabButtonSelectedBorderBottomWidth: 0,
        tabButtonSelectedBorderStyle: 'solid',
        tabButtonSelectedBorderTopLeftRadius: 0,
        tabButtonSelectedBorderTopRightRadius: 0,
        tabButtonSelectedBorderBottomLeftRadius: 0,
        tabButtonSelectedBorderBottomRightRadius: 0,
        tabButtonTextFontFamily: 'System',
        tabButtonTextFontWeight: 'normal',
        tabButtonTextFontColor: '#000000',
        tabButtonTextFontSize: 18,
        tabButtonTextFontStyle: 'normal',
        tabButtonTextTextDecoration: 'none',
        tabButtonTextTextTransform: 'none',
        tabButtonTextTextShadowColor: '#ffffff',
        tabButtonTextTextShadowRadius: 0,
        tabButtonTextLetterSpacing: 0,
        tabButtonTextNumberOfLines: 1,
        tabButtonTextEllipsizeMode: 'tail',
        tabButtonTextFlexDirection: 'row',
        tabButtonTextJustifyContent: 'center',
        tabButtonTextAlignItems: 'center',
        tabButtonTextPaddings: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingRight: 0,
            paddingBottom: 0,
        },
        tabButtonTextBorderLeftColor: '#ffffff',
        tabButtonTextBorderLeftWidth: 0,
        tabButtonTextBorderRightColor: '#ffffff',
        tabButtonTextBorderRightWidth: 0,
        tabButtonTextBorderTopColor: '#ffffff',
        tabButtonTextBorderTopWidth: 0,
        tabButtonTextBorderBottomColor: '#ffffff',
        tabButtonTextBorderBottomWidth: 0,
        tabButtonTextBorderStyle: 'solid',
        tabButtonTextBorderTopLeftRadius: 0,
        tabButtonTextBorderTopRightRadius: 0,
        tabButtonTextBorderBottomLeftRadius: 0,
        tabButtonTextBorderBottomRightRadius: 0,
        tabButtonTextSelectedFontFamily: 'System',
        tabButtonTextSelectedFontWeight: 'normal',
        tabButtonTextSelectedFontColor: '#000000',
        tabButtonTextSelectedFontSize: 18,
        tabButtonTextSelectedFontStyle: 'normal',
        tabButtonTextSelectedTextDecoration: 'none',
        tabButtonTextSelectedTextTransform: 'none',
        tabButtonTextSelectedTextShadowColor: '#ffffff',
        tabButtonTextSelectedTextShadowRadius: 0,
        tabButtonTextSelectedLetterSpacing: 0,
        tabButtonTextSelectedNumberOfLines: 1,
        tabButtonTextSelectedEllipsizeMode: 'tail',
        tabButtonTextSelectedFlexDirection: 'row',
        tabButtonTextSelectedJustifyContent: 'center',
        tabButtonTextSelectedAlignItems: 'center',
        tabButtonTextSelectedPaddings: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingRight: 0,
            paddingBottom: 0,
        },
        tabButtonTextSelectedBorderLeftColor: '#ffffff',
        tabButtonTextSelectedBorderLeftWidth: 0,
        tabButtonTextSelectedBorderRightColor: '#ffffff',
        tabButtonTextSelectedBorderRightWidth: 0,
        tabButtonTextSelectedBorderTopColor: '#ffffff',
        tabButtonTextSelectedBorderTopWidth: 0,
        tabButtonTextSelectedBorderBottomColor: '#ffffff',
        tabButtonTextSelectedBorderBottomWidth: 0,
        tabButtonTextSelectedBorderStyle: 'solid',
        tabButtonTextSelectedBorderTopLeftRadius: 0,
        tabButtonTextSelectedBorderTopRightRadius: 0,
        tabButtonTextSelectedBorderBottomLeftRadius: 0,
        tabButtonTextSelectedBorderBottomRightRadius: 0,
        tabButtonIconColor: '#ffffff',
        tabButtonIconPaddings: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingRight: 0,
            paddingBottom: 0,
        },
        tabButtonIconSelectedColor: '#ffffff',
        tabButtonIconSelectedPaddings: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingRight: 0,
            paddingBottom: 0,
        },
        calendarBackground: '#ffffff',
        calendarTextSectionTitleColor: '#b6c1cd',
        calendarSelectedDayBackgroundColor: '#36e0b7',
        calendarSelectedDayTextColor: '#000000',
        calendarTodayTextColor: '#000000',
        calendarDayTextColor: '#2d4150',
        calendarTextDisabledColor: '#d9e1e8',
        calendarMonthTextColor: '#2d4150',
        calendarTextDayFontFamily: 'System',
        calendarTextDayFontSize: 16,
        calendarTextDayFontWeight: '300',
        calendarTextMonthFontFamily: 'System',
        calendarTextMonthFontWeight: 'bold',
        calendarTextMonthFontSize: 16,
        calendarTextDayHeaderFontFamily: 'System',
        calendarTextDayHeaderFontWeight: '300',
        calendarTextDayHeaderFontSize: 16,
        calendarMonthNextButtonIcon: faAngleRight,
        calendarMonthNextButtonIconColor: '#000000',
        calendarMonthPreviousButtonIcon: faAngleLeft,
        calendarMonthPreviousButtonIconColor: '#000000',
        supportingColor1: '#619863',
        supportingColor2: '#13958e',
        supportingColor3: '#eeeeee',
        searchBarColor: 'transparent',
        searchBackgroundColor: 'transparent',
        headerFontFamily: 'System',
        headerFontWeight: 'bold',
        headerFontColor: '#000000',
        headerFontSize: 18,
        headerFontStyle: 'normal',
        headerTextDecoration: 'none',
        headerTextTransform: 'none',
        headerTextShadowColor: 'transparent',
        headerTextShadowRadius: 0,
        headerLetterSpacing: 0,
        headerNumberOfLines: 1,
        headerEllipsizeMode: 'clip',
        menuFontFamily: 'System',
        menuFontWeight: 'bold',
        menuFontColor: '#000000',
        menuFontSize: 18,
        menuFontStyle: 'normal',
        menuTextDecoration: 'none',
        menuTextTransform: 'none',
        menuTextShadowColor: 'transparent',
        menuTextShadowRadius: 0,
        menuLetterSpacing: 0,
        menuNumberOfLines: 1,
        menuEllipsizeMode: 'clip',
        bodyFontFamily: 'System',
        bodyFontWeight: 'normal',
        bodyFontColor: '#222222',
        bodyFontSize: 14,
        bodyFontStyle: 'normal',
        bodyTextDecoration: 'none',
        bodyTextTransform: 'none',
        bodyTextShadowColor: 'transparent',
        bodyTextShadowRadius: 0,
        bodyLetterSpacing: 0,
        bodyNumberOfLines: 1,
        bodyEllipsizeMode: 'clip',
        borderLeftColor: '#cccccc',
        borderLeftWidth: 1,
        borderRightColor: '#cccccc',
        borderRightWidth: 1,
        borderTopColor: '#cccccc',
        borderTopWidth: 1,
        borderBottomColor: '#cccccc',
        borderBottomWidth: 1,
        borderStyle: 'solid',
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        paddings: {
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: 0,
            paddingRight: 0,
        },
        transition: {
            type: 'none',
            duration: '250',
        },
        drawerShadow: false,
        swatches: [
            '#000000',
            '#ffffff',
            '#ff0000',
            '#00ff00',
            '#0000ff',
            '#36e0b7',
            '#0e3951',
            '#ff00ff',
            '#00ffff',
            '#f0f0f0',
        ],
        colorStyles: [
            { id: 'color:1', name: 'Primary', value: '#0FC08D' },
            { id: 'color:2', name: 'Primary Shade', value: '#0B906A' },
            { id: 'color:3', name: 'Secondary', value: '#0F96C0' },
            { id: 'color:4', name: 'Secondary Shade', value: '#0B7190' },
            { id: 'color:5', name: 'Background', value: '#F8F8FB' },
            { id: 'color:6', name: 'Text', value: '#252525' },
            { id: 'color:7', name: 'Subtext', value: '#696969' },
            { id: 'color:8', name: 'Info', value: '#7496EB' },
            { id: 'color:9', name: 'Warning', value: '#FF9966' },
            { id: 'color:10', name: 'Error', value: '#FF6666' },
        ],
        textStyles: [
            {
                id: 'text:1',
                name: 'Title 1',
                values: {
                    fontFamily: 'Open Sans',
                    fontSize: 24,
                    fontWeight: '700',
                    letterSpacing: 0,
                },
            },
            {
                id: 'text:2',
                name: 'Title 2',
                values: {
                    fontFamily: 'Open Sans',
                    fontSize: 24,
                    fontWeight: '600',
                    letterSpacing: 0,
                },
            },
            {
                id: 'text:3',
                name: 'Title 3',
                values: {
                    fontFamily: 'Open Sans',
                    fontSize: 22,
                    fontWeight: '600',
                    letterSpacing: 0,
                },
            },
            {
                id: 'text:4',
                name: 'Title 4',
                values: {
                    fontFamily: 'Open Sans',
                    fontSize: 22,
                    fontWeight: '400',
                    letterSpacing: 0,
                },
            },
            {
                id: 'text:5',
                name: 'Subtitle 2',
                values: {
                    fontFamily: 'Open Sans',
                    fontSize: 18,
                    fontWeight: '400',
                    letterSpacing: 0,
                },
            },
            {
                id: 'text:6',
                name: 'Subtitle 2',
                values: {
                    fontFamily: 'Open Sans',
                    fontSize: 18,
                    fontWeight: '400',
                    letterSpacing: 0,
                },
            },
            {
                id: 'text:7',
                name: 'Body Text 1',
                values: {
                    fontFamily: 'Open Sans',
                    fontSize: 18,
                    fontWeight: '400',
                    letterSpacing: 0,
                },
            },
            {
                id: 'text:8',
                name: 'Body Text 2',
                values: {
                    fontFamily: 'Open Sans',
                    fontSize: 16,
                    fontWeight: '400',
                    letterSpacing: 0,
                },
            },
            {
                id: 'text:9',
                name: 'Button Text',
                values: {
                    fontFamily: 'Open Sans',
                    fontSize: 16,
                    fontWeight: '600',
                    letterSpacing: 0,
                },
            },
            {
                id: 'text:10',
                name: 'Subtext',
                values: {
                    fontFamily: 'Open Sans',
                    fontSize: 12,
                    fontWeight: '400',
                    letterSpacing: 0,
                },
            },
        ],
    },
    styles_error: false,
};
function StructureBuilderPageReducer(currentState, action) {
    if (currentState === void 0) { currentState = initialState; }
    return produce(currentState, function (state) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        switch (action.type) {
            case LOAD_DATASET_ROWS_REQUEST:
                state.dataset_rows_loading = true;
                state.dataset_rows_error = false;
                break;
            case LOAD_DATASET_ROWS_SUCCESS:
                state.datasetRows[action.datasetId] = action.datasetRows;
                state.dataset_rows_loading = false;
                state.dataset_rows_error = false;
                break;
            case LOAD_DATASET_ROWS_FAILURE:
                state.dataset_rows_loading = false;
                state.dataset_rows_error = true;
                break;
            case REFRESH_PATCHWORK_REQUEST:
                state.viewState = viewStates.init;
                break;
            case LOAD_PATCHWORK_REQUEST:
                state.viewState = viewStates.loading;
                state.patchwork = { entrypoint: null, patches: [], edges: [] };
                break;
            case LOAD_PATCHWORK_SUCCESS:
                state.viewState = viewStates.normal;
                state.patchwork = action.patchwork || {
                    entrypoint: null,
                    originalEntrypoint: null,
                    patches: [],
                    edges: [],
                };
                state.patchwork.originalEntrypoint = action.patchwork.entrypoint;
                state.meta = action.meta;
                break;
            case LOAD_PATCHWORK_FAILURE:
                state.viewState = viewStates.error;
                break;
            case UPDATE_PATCHWORK_REQUEST:
                state.viewState = viewStates.loading;
                break;
            case UPDATE_PATCHWORK_SUCCESS:
                state.viewState = viewStates.normal;
                state.patchwork = action.patchwork || {
                    entrypoint: null,
                    patches: [],
                    edges: [],
                };
                break;
            case UPDATE_PATCHWORK_FAILURE:
                state.viewState = viewStates.error;
                break;
            case UPDATE_PATCHWORK_ENTRYPOINT:
                state.viewState = viewStates.loading;
                break;
            case UPDATE_PATCHWORK_ENTRYPOINT_SUCCESS:
                state.viewState = viewStates.normal;
                state.patchwork.entrypoint = action.entrypoint;
                break;
            case UPDATE_PATCHWORK_ENTRYPOINT_FAIL:
                state.viewState = viewStates.error;
                break;
            case CREATE_PATCH_REQUEST:
                state.viewState = viewStates.loading;
                state.temp_new_patch = null;
                break;
            case CREATE_PATCH_SUCCESS:
                state.viewState = viewStates.normal;
                state.patchwork.patches.push(action.patch);
                state.temp_new_patch = action.patch;
                break;
            case CREATE_PATCH_FAILURE:
                state.viewState = viewStates.error;
                state.temp_new_patch = null;
                break;
            case CREATE_EDGE_REQUEST:
                state.viewState = viewStates.loading;
                break;
            case CREATE_EDGE_SUCCESS:
                state.viewState = viewStates.normal;
                state.patchwork.edges.push(action.edge);
                break;
            case CREATE_EDGE_FAILURE:
                state.viewState = viewStates.error;
                break;
            case UPDATE_PATCH_REQUEST:
                state.viewState = viewStates.loading;
                if (action.patch) {
                    var patchIndex = state.patchwork.patches.findIndex(function (patch) { return patch.id === action.patch.id; });
                    if (patchIndex > -1) {
                        state.patchwork.patches[patchIndex] = action.patch;
                    }
                }
                break;
            case UPDATE_PATCH_SUCCESS:
                state.viewState = viewStates.normal;
                if (action.patch) {
                    for (var i = 0; i < state.patchwork.patches.length; i++) {
                        var patch = state.patchwork.patches[i];
                        if (patch.id === ((_a = action.patch) === null || _a === void 0 ? void 0 : _a.id)) {
                            state.patchwork.patches[i] = action.patch;
                        }
                    }
                }
                break;
            case UPDATE_PATCH_FAILURE:
                state.viewState = viewStates.error;
                break;
            case UPDATE_PATCH_COORDS_REQUEST:
                state.viewState = viewStates.loading;
                break;
            case UPDATE_PATCH_COORDS_SUCCESS:
                state.viewState = viewStates.normal;
                state.patchwork = (_b = action.patchwork) !== null && _b !== void 0 ? _b : {
                    entrypoint: null,
                    patches: [],
                    edges: [],
                };
                break;
            case UPDATE_PATCH_COORDS_FAILURE:
                state.viewState = viewStates.error;
                break;
            case LOAD_DATASET_REQUEST:
                state.datasets_loading = true;
                state.datasets = [];
                state.datasets_error = false;
                break;
            case LOAD_DATASET_SUCCESS:
                state.datasets_loading = false;
                state.datasets = action.datasets;
                state.datasets_error = false;
                break;
            case LOAD_DATASET_FAILURE:
                state.datasets_loading = false;
                state.datasets = [];
                state.datasets_error = true;
                break;
            case LOAD_VIEW_REQUEST:
                state.views_loading = true;
                state.views = [];
                state.views_error = false;
                break;
            case LOAD_VIEW_SUCCESS:
                state.views_loading = false;
                state.views = action.views;
                state.views_error = false;
                break;
            case LOAD_VIEW_FAILURE:
                state.views_loading = false;
                state.views = [];
                state.views_error = true;
                break;
            case DELETE_PATCH_REQUEST:
                state.viewState = viewStates.loading;
                state.patch_deleting = true;
                state.patch_delete_error = false;
                break;
            case DELETE_PATCH_SUCCESS:
                state.viewState = viewStates.normal;
                state.patch_deleting = false;
                state.patch_delete_error = false;
                break;
            case DELETE_PATCH_FAILURE:
                state.viewState = viewStates.error;
                state.patch_delete_error = true;
                state.patch_deleting = false;
                break;
            case BULK_DELETE_PATCHES_REQUEST:
                state.viewState = viewStates.loading;
                state.patch_deleting = true;
                state.patch_delete_error = false;
                break;
            case BULK_DELETE_PATCHES_SUCCESS:
                state.viewState = viewStates.normal;
                state.patch_deleting = false;
                state.patch_delete_error = false;
                break;
            case BULK_DELETE_PATCHES_FAILURE:
                state.viewState = viewStates.error;
                state.patch_delete_error = true;
                state.patch_deleting = false;
                break;
            case DELETE_EDGE_REQUEST:
                state.viewState = viewStates.loading;
                state.edge_deleting = true;
                state.edge_delete_error = false;
                break;
            case DELETE_EDGE_SUCCESS: {
                state.viewState = viewStates.normal;
                state.edge_deleting = false;
                state.edge_delete_error = false;
                state.patchwork.edges = state.patchwork.edges.filter(function (e) { return e.id !== action.edgeId; });
                var foundPatchIndex = findPatchIndex(action.edgeId, state.patchwork);
                if (foundPatchIndex > -1 &&
                    state.patchwork.patches[foundPatchIndex].settings) {
                    state.patchwork.patches[foundPatchIndex].settings.items.filter(function (i) { return i.id !== action.edgeId; });
                    state.patchwork.patches[foundPatchIndex].settings.contextItems.filter(function (i) { return i.id !== action.edgeId; });
                }
                break;
            }
            case DELETE_EDGE_FAILURE:
                state.viewState = viewStates.error;
                state.edge_delete_error = true;
                state.edge_deleting = false;
                break;
            case UPDATE_EDGE_REQUEST:
                state.viewState = viewStates.loading;
                break;
            case UPDATE_EDGE_SUCCESS:
                state.viewState = viewStates.normal;
                state.patchwork.edges = __spreadArray(__spreadArray([], state.patchwork.edges.filter(function (e) { return e.id !== action.edge.id; }), true), [
                    action.edge,
                ], false);
                break;
            case UPDATE_EDGE_FAILURE:
                state.viewState = viewStates.error;
                break;
            case LOAD_GROUPS_REQUEST:
                state.groups_loading = true;
                state.groups_error = false;
                break;
            case LOAD_GROUPS_SUCCESS:
                state.groups = action.groups;
                state.meta = action.meta;
                state.groups_loading = false;
                state.groups_error = false;
                break;
            case LOAD_GROUPS_FAILURE:
                state.groups_loading = false;
                state.groups_error = true;
                break;
            case LOAD_ICONS_REQUEST:
                state.icons_loading = true;
                state.icons_error = false;
                break;
            case LOAD_ICONS_SUCCESS:
                state.icons = action.icons;
                state.icons_loading = false;
                state.icons_error = false;
                break;
            case LOAD_ICONS_FAILURE:
                state.icons_loading = false;
                state.icons_error = action.err;
                break;
            case SET_LOADING_STATE:
                state.viewState = viewStates.loading;
                break;
            case LOAD_FILES_REQUEST:
                state.loading = true;
                state.error = false;
                break;
            case LOAD_FILES_SUCCESS:
                state.files = action.files;
                state.icons = action.icons;
                state.filesMeta = action.meta;
                state.loading = false;
                state.error = false;
                break;
            case LOAD_FILES_FAILURE:
                state.loading = false;
                state.error = action.err;
                break;
            case UPDATE_CANVAS_OFFSET:
                state.canvasOffset.x = action.canvasOffset.x;
                state.canvasOffset.y = action.canvasOffset.y;
                break;
            case LOAD_INTEGRATION_REQUEST:
                state.integrations_loading = true;
                state.integrations = [];
                state.integrations_error = false;
                break;
            case LOAD_INTEGRATION_SUCCESS:
                state.integrations_loading = false;
                state.integrations = action.integrations;
                state.integrations_error = false;
                break;
            case LOAD_INTEGRATION_FAILURE:
                state.integrations_loading = false;
                state.integrations = [];
                state.integrations_error = true;
                break;
            case SELECT_GROUP:
                state.selectedGroup = action.groupId || null;
                state.selectGroupChanging = false;
                break;
            case SELECT_GROUP_CHANGING:
                state.selectGroupChanging = true;
                break;
            case COPY_LOGIC_REQUEST:
                state.viewState = viewStates.loading;
                break;
            case COPY_LOGIC_SUCCESS:
                state.viewState = viewStates.normal;
                state.patchwork = action.patchwork;
                break;
            case COPY_LOGIC_FAILURE:
                state.viewState = viewStates.error;
                break;
            case COPY_LOGIC_GROUP_REQUEST:
                state.viewState = viewStates.loading;
                break;
            case COPY_LOGIC_GROUP_SUCCESS:
                state.viewState = viewStates.normal;
                state.patchwork = action.patchwork;
                state.focalPatch = ((_c = action === null || action === void 0 ? void 0 : action.patchwork) === null || _c === void 0 ? void 0 : _c.focalPatch) || '';
                break;
            case COPY_LOGIC_GROUP_FOCAL_PATCH:
                state.focalPatch = ((_e = (_d = action.copyData) === null || _d === void 0 ? void 0 : _d.meta_data) === null || _e === void 0 ? void 0 : _e.patch_id) || '';
                break;
            case COPY_LOGIC_GROUP_FAILURE:
                state.viewState = viewStates.error;
                break;
            case CREATE_VIEW_EVENT_REQUEST:
                state.viewState = viewStates.loading;
                break;
            case CREATE_VIEW_EVENT_SUCCESS:
                state.viewState = viewStates.normal;
                break;
            case CREATE_VIEW_EVENT_FAILURE:
                state.viewState = viewStates.error;
                break;
            case CREATE_VIEW_REQUEST:
                state.viewState = viewStates.loading;
                state.created_view = null;
                break;
            case CREATE_VIEW_SUCCESS:
                state.viewState = viewStates.normal;
                state.created_view = action.view;
                break;
            case CREATE_VIEW_FAILURE:
                state.viewState = viewStates.error;
                state.created_view = null;
                break;
            case CHANGE_VIEW_NAME_REQUEST:
                state.viewState = viewStates.loading;
                break;
            case CHANGE_VIEW_NAME_SUCCESS:
                state.viewState = viewStates.normal;
                var viewIndex = -1;
                if ((_f = action.payload) === null || _f === void 0 ? void 0 : _f.viewId) {
                    viewIndex = (_g = state.views) === null || _g === void 0 ? void 0 : _g.findIndex(function (view) { return view.id === action.payload.viewId; });
                }
                if (viewIndex > -1 &&
                    ((_h = action.payload) === null || _h === void 0 ? void 0 : _h.viewName) &&
                    ((_j = state.views) === null || _j === void 0 ? void 0 : _j[viewIndex])) {
                    state.views[viewIndex].name = action.payload.viewName;
                }
                break;
            case CHANGE_VIEW_NAME_FAILURE:
                state.viewState = viewStates.error;
                break;
            case SET_GLOBAL_STYLES_REQUEST:
                state.styles_loading = true;
                state.styles_error = false;
                break;
            case SET_GLOBAL_STYLES_SUCCESS:
                state.styles_data = action.style.data;
                state.styles_loading = false;
                state.styles_error = false;
                break;
            case SET_GLOBAL_STYLES_FAILURE:
                state.styles_error = true;
                state.styles_loading = false;
                break;
            default:
                break;
        }
    });
}
export default StructureBuilderPageReducer;
